import React from 'react';
import { useEnochFilterContext } from './context';
import { useEnochHistogramReport } from '../../../query/enoch';
import { Line } from 'react-chartjs-2';
import {
  Chart,
  TimeScale,
  Tooltip,
  Legend,
  LinearScale,
  PointElement,
  LineElement,
} from 'chart.js';
import 'chartjs-adapter-moment';

import { Row, Spin } from 'antd';
import moment from 'moment/moment';

Chart.register(
  Tooltip,
  Legend,
  TimeScale,
  LinearScale,
  PointElement,
  LineElement,
);

export default function HistogramEnochReport() {
  const filter = useEnochFilterContext();
  const { data, isLoading } = useEnochHistogramReport(filter);
  const isTimeRangeSupported =
    moment(filter.toDate).diff(moment(filter.fromDate), 'days') <= 100;
  return (
    <>
      {!isTimeRangeSupported && (
        <p>
          This time range is not supported in this graph for performance issue.
          Last 30 days is applied
        </p>
      )}
      <Spin spinning={isLoading}>
        <Row gutter={16}>
          <Line
            data={{
              datasets: Object.entries(labelMapping).map(
                ([key, label], index) => {
                  return {
                    label,
                    borderColor: colorScheme[index],
                    data: (data || []).map(item => {
                      return {
                        x: item.date,
                        y: item[key],
                      };
                    }),
                  };
                },
              ),
            }}
            options={{
              maintainAspectRatio: false,
              scales: {
                x: {
                  type: 'time',
                  time: {
                    unit: 'day',
                  },
                },
              },
            }}
            style={{ height: 400 }}
          />
        </Row>
      </Spin>
    </>
  );
}

const labelMapping = {
  numOfSpams: 'Total Spams Found',
  numOfSpamsMoved: 'Total Spams Moved to Inbox',
  numOfPromotions: 'Total Promotions Found',
  numOfPromotionsMoved: 'Total Promotions Moved to Inbox',
  numOfUnimportant: 'Total Unimportant Found',
  numOfUnimportantMoved: 'Total Unimportant Marked as Important',
  numOfInboxes: 'Total Inboxes Found',
  numOfInboxesReplied: 'Total Inboxes Replied',
};

const colorScheme = [
  '#f1c40f',
  '#ff7f50',
  '#ff6b81',
  '#ffa502',
  '#7bed9f',
  '#70a1ff',
  '#1e90ff',
  '#fab1a0',
  '#ff7675',
  '#fd79a8',
  '#fdcb6e',
  '#e17055',
  '#d63031',
  '#feca57',
  '#5f27cd',
  '#54a0ff',
  '#01a3a4',
];
